import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { DownArrowIcon } from 'views/ui/icons';

import { Theme } from 'ui_system/theme';
import { breakpoints } from 'ui_system/token_auth/styles_root';

const Container = styled.div`
  display: grid;
  grid-template-columns: 33% 33% 33%;
  align-items: center;

  background: ${Theme.colors.black};
  height: 44px;
  padding: 0px 20px 0px 20px;
  color: white;
  font-size: 16px;

  @media (max-width: ${breakpoints[1]}px) {
    grid-template-columns: 33% 33% 33%;
  }
`;

const Section = styled.div`
  width: 100%;
  text-align: ${(props) => props.align};
  overflow: visible;
  white-space: nowrap;
`;
const Button = styled.button`
  &:focus {
    outline: 0;
  }
  &:disabled {
    div {
      color: ${Theme.colors.lightText};
    }
  }
`;
const BackArrow = styled(DownArrowIcon)`
  transform: rotate(90deg);
  fill: ${Theme.colors.lightText};
  height: 9px;
  margin-right: 12px;
`;

const Text = styled.div`
  display: inline-block;
  /* color: ${(props) => (props.action ? Theme.colors.lightText : 'white')}; */
  color: white;
`;

const Title = styled(Text)`
  display: block;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const NavigationBar = ({
  onBack,
  backText,
  title,
  onAction,
  actionText,
  actionDisabled,
}) => {
  return (
    <Container>
      <Section align="left">
        <Button onClick={onBack}>
          <BackArrow />
          <Text>{backText}</Text>
        </Button>
      </Section>
      <Section align="center">
        <Title>{title}</Title>
      </Section>
      <Section align="right">
        <Button disabled={actionDisabled} onClick={onAction}>
          <Text>{actionText}</Text>
        </Button>
      </Section>
    </Container>
  );
};

NavigationBar.defaultProps = {
  onBack: null,
  backText: '',
  title: '',
  onAction: null,
  actionText: '',
  actionDisabled: false,
};

NavigationBar.propTypes = {
  onBack: PropTypes.func,
  backText: PropTypes.string,
  title: PropTypes.string,
  onAction: PropTypes.func,
  actionText: PropTypes.string,
  actionDisabled: PropTypes.bool,
};

export default NavigationBar;
